export default {
  strict: true,
  namespaced: true,
  state: {
    priceExp: 'servicePrice',
    exp: {}
  },
  mutations: {
    setExperimentData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/experiment.js